import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import folder from "../assets/images/ticket1.png";
import back from "../assets/images/back_arrow.png";
import plus from "../assets/images/plus.png";
import Axios from "axios";
import Spinner from "../components/Spinner";
import "../css/Header.css";
import { message } from "antd";
const moment = require("moment");

const Tickets = () => {
  let phoneno = localStorage.getItem("phoneNo");
  const [tickets, setTickets] = useState([]);
  const [msg, setmsg] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/");
  };

  const addTicketHandler = () => {
    navigate("/AddTicket");
  };

  useEffect(() => {
    const fetchTickets = async () => {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
      };

      setmsg(""); // Clear any previous message
      setLoading(true); // Set loading state while fetching

      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientsSupport/get_tickets_by_phoneno?phone_no=${phoneno}&MDT=PM&user_role=rp`,
          { headers }
        );

        if (response.data.status == '1') {
          if (response.data.data.length > 0) {
            setTickets(response.data.data);
          } else {
            setmsg(
              "No Issues found. Click on Add Ticket Button for any issues."
            );
          }
        } else if (response.data.status == '401') {
          console.error("Unauthorized access. Logging out.");
          message.error("Unauthorized access. Logging out.");
          logoutHandler();
        } else if (response.data.status == '0') {
          setmsg(
            "An error occurred while fetching tickets. Please try again later."
          );
        }
      } catch (error) {
        if (error.response && error.response.status == '401') {
          console.error("Unauthorized access. Logging out.");
          setmsg("Session expired. Please log in again.");
          message.error("Unauthorized access. Logging out.");
          logoutHandler();
        } else {
          console.error("Error:", error.message);
          setmsg(
            "An error occurred while fetching tickets. Please try again later."
          );
        }
      } finally {
        setLoading(false); // Ensure loading state is stopped in all cases
      }
    };

    fetchTickets();
  }, [phoneno]);

  const logoutHandler = () => {
    localStorage.clear();
    navigate("/Login");
  };

  return (
    <div className="background-container-ticket">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <header className="header">
            <img
              src={back}
              style={{ height: 20, width: 20 }}
              alt="back button"
              onClick={backHandler}
            />
            <h1 className="header-title">Support Issues</h1>
          </header>
          <p style={{ fontSize: 15, fontWeight: "bold", color: "black" }}>
            We are committed to solve your problem
          </p>
          <div className="scrollable-area">
            {msg ? (
              <p
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  color: "red",
                  marginTop: 20,
                }}
              >
                {msg}
              </p>
            ) : null}
              {tickets.map((details) => (
                <div
                  key={details.id}
                  className="medical-records-cards"
                  onClick={() => navigate("/ViewTicket", { state: details })}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={folder}
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                        alt="folder"
                      />
                      <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                        Ticket No: {details.ticket_number}
                      </p>
                    </div>
                    <p style={{ fontSize: "12px", color: "#666", marginLeft: 50}}>
                      {moment(details.create_datetime).format("DD.MM.YYYY")}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          {/* Full-Width Add Ticket Button */}
          <button className="add-ticket-button" onClick={addTicketHandler}>
            Add Ticket
          </button>
        </>
      )}
    </div>
  );
};

export default Tickets;
